import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslocoModule} from '@jsverse/transloco';
import {DefaultSelectComponent} from './components/default-select/default-select.component';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LowercaseTranslocoPipe} from './pipes/transloco-pipe/LowerCaseTranslocoPipe';
import {DefaultContainerTabsComponent} from './components/default-container-tabs/default-container-tabs.component';
import {TabViewModule} from 'primeng/tabview';
import {CustomTabComponent} from './components/custom-tap/custom-tab.component';
import {StateColumnComponent} from './components/columns/state-column/state-column.component';
import {TooltipModule} from 'primeng/tooltip';
import {ProtocolHeaderComponent} from './components/protocol/protocol-header/protocol-header.component';
import {ChipModule} from 'primeng/chip';
import {ProtocolNoteModalComponent} from './components/protocol/protocol-note-modal/protocol-note-modal.component';
import {EditorModule} from 'primeng/editor';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {ToastModule} from 'primeng/toast';
import {InputTextModule} from 'primeng/inputtext';
import {FloatLabelModule} from 'primeng/floatlabel';
import {ThemeDirective} from "./directives/theme/theme-directive.directive";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {FieldsetModule} from "primeng/fieldset";


@NgModule({
  declarations: [DefaultSelectComponent, DefaultContainerTabsComponent, CustomTabComponent, StateColumnComponent,
    ProtocolHeaderComponent, ProtocolNoteModalComponent],
    imports: [
        CommonModule,
        TranslocoModule,
        DropdownModule,
        TabViewModule,
        FormsModule,
        ReactiveFormsModule,
        LowercaseTranslocoPipe,
        TooltipModule,
        ChipModule,
        EditorModule,
        ButtonModule,
        DialogModule,
        ToastModule,
        InputTextModule,
        FloatLabelModule,
        ThemeDirective,
        ConfirmDialogModule,
        FieldsetModule,
    ],
  exports: [
    DefaultSelectComponent,
    TabViewModule,
    CustomTabComponent,
    LowercaseTranslocoPipe,
    DefaultContainerTabsComponent,
    StateColumnComponent,
    ProtocolHeaderComponent,
    ProtocolNoteModalComponent,
    ThemeDirective
  ]}
)
export class SharedModule {
  // static forRoot(): ModuleWithProviders<SharedModule> {
  //   return {
  //     ngModule: SharedModule,
  //     providers: [SharedUtils, ConfirmationService] // Ecco il servizio che sarà unico per tutta l'app
  //   };
  // }


}
